export default {
  fr: {
    conditions_updated_title: "Mise-à-jour des conditions d'utilisation",
    conditions_updated_text:
      "Pour améliorer votre expérience, voici ce qu'on a modifié aux conditions d'utilisation:",
    read_all_conditions: "Veuillez consulter les {0} et ré-approuver.",
    conditions: "conditions d'utilisation",
    accept_updates_button: "Je réapprouve !",
    unregister_link: "Je veux me désinscrire",
    unregister_instructions: "Envoyez un courriel à {0} pour vous désinscrire.",
    updates: {
    },
  },
};
